import axios from "axios";
import { $t } from "@/config/i18n";

// Services
import handleLogout from "@/services/logout";

axios.interceptors.response.use(
  function (res) {
    return Promise.resolve(res);
  },
  async (error) => {
    const err = error;
    if (err.response) {
      switch (err.response.status) {
        case 401:
          err.message = $t("errorCode.401");
          handleLogout();
          break;
        case 403:
          err.message = $t("errorCode.403");
          break;
        case 404:
          err.message = $t("errorCode.404");
          break;
        case 500:
          err.message = $t("errorCode.500");
          break;
        default:
          err.message = err.response.data.error_description || err.message;
          break;
      }
      if (err.response.data.error_description) {
        err.message = err.response.data.error_description;
      }
    }

    return Promise.reject(err);
  }
);

export default axios;
